{
  "alert": "Brīdinājums",
  "dismiss": "Nerādīt"
}
